var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",class:( _obj = { 'icon-spin': _vm.spin }, _obj[("icon-" + _vm.name)] = _vm.name, _obj )},[_c('use',{attrs:{"xlink:href":("#" + _vm.name)}})])
var _obj;}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c67974c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Icon.vue
// module id = IyN3
// module chunks = 0